import { z } from 'zod';
/**
 * Comments & Mentions — Skill `comments-mentions` (Paket C).
 *
 * Single Source of Truth für Request-Schemas und DTOs.
 * Backend validiert mit den Zod-Schemas; Frontend tippt API-Responses gegen die Interfaces.
 */
export const createCommentRequest = z
    .object({
    body: z.string().min(1).max(5000),
    fieldKey: z.string().max(80).optional(),
    parentId: z.number().int().positive().optional(),
})
    .strict();
export const updateCommentRequest = z
    .object({
    body: z.string().min(1).max(5000),
})
    .strict();
